"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.submitRateEnquiry = void 0;
const helpers_1 = require("../../helpers");
const agents_1 = require("../agents");
const formatDateFriendly_1 = require("../formatDateFriendly");
const mailchimp_1 = require("../mailchimp");
const sendEmail_1 = require("../sendEmail");
const users_1 = require("../users");
const getCourseById_1 = require("./getCourseById");
const submitRateEnquiry = async (supabase, enquiry_obj) => {
    const errors = [];
    const user = await (0, users_1.createOrFindUser)({
        supabase,
        agent_id: enquiry_obj.agent_id || "",
        email: enquiry_obj.email,
        first_name: enquiry_obj.first_name,
        last_name: enquiry_obj.last_name,
        phone: enquiry_obj.phone,
        user_type: enquiry_obj.create_account ? "client" : "guest",
        country_of_residence: enquiry_obj.country_of_residence,
        display_currency: enquiry_obj.display_currency || "THB",
        site_id: enquiry_obj.site_id,
    });
    let agent = {};
    if (enquiry_obj.agent_id) {
        agent = await (0, agents_1.getAgentById)(supabase, enquiry_obj?.agent_id);
    }
    const course = await (0, getCourseById_1.getCourseById)(supabase, enquiry_obj.course_id);
    delete enquiry_obj.agent_id;
    if (!user) {
        return { success: false, data: "User Creation Failed" };
    }
    const join_mailing_list = enquiry_obj.join_mailing_list;
    try {
        if (join_mailing_list) {
            await (0, mailchimp_1.addToMailingList)(enquiry_obj.email, enquiry_obj?.tags || []);
        }
    }
    catch (error) {
        console.log("Failed to add to mailing list", error);
    }
    // remove the mailing list and tags from the enquiry object
    delete enquiry_obj.join_mailing_list;
    delete enquiry_obj.tags;
    // set the client id so this enquiry can be tracked and linked to the user
    enquiry_obj.client_id = user.id;
    const { data, error } = await supabase
        .from("rate_enquiries")
        .insert([enquiry_obj])
        .select()
        .single();
    if (error) {
        errors.push(error);
    }
    if (errors.length > 0) {
        return { success: false, data: errors };
    }
    const rate_enquiry_email_obj = {
        language_code: "en",
        template_id: helpers_1.EMAIL_GOLF_RATE_ENQUIRY,
        data: {
            ...enquiry_obj,
            reference: data?.reference,
            record_id: data?.id,
            date: (0, formatDateFriendly_1.formatDateFriendly)(enquiry_obj.date),
            client: user,
            agent: agent,
            course: {
                id: course.id,
                name: course.name.en,
            },
        },
    };
    await (0, sendEmail_1.sendEmail)(rate_enquiry_email_obj);
    const support_rate_enquiry_email_obj = {
        ...rate_enquiry_email_obj,
        template_id: helpers_1.SUPPORT_EMAIL_GOLF_RATE_ENQUIRY,
    };
    await (0, sendEmail_1.sendEmail)(support_rate_enquiry_email_obj);
    return {
        success: true,
        data: data,
    };
};
exports.submitRateEnquiry = submitRateEnquiry;
